import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MdbButtonModule } from 'src/lib/mdb5-adapted/public-api';

import { PageheaderCardModule } from 'src/app/shared/ui/pageheader-card/pageheader-card.module';

import { LMS_NoSpecialsDirective, UpperCaseInputDirective } from '@lmsSharedUI';

import { RegionAdminDialogComponent } from './region-admin-dialog/region-admin-dialog.component';
import { RegionsAddComponent } from './regions-add/regions-add.component';
import { RegionsAdminComponent } from './regions-admin.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MdbButtonModule,
    PageheaderCardModule,
    LMS_NoSpecialsDirective,
    UpperCaseInputDirective,
    RegionsAdminComponent,
    RegionAdminDialogComponent,
    RegionsAddComponent,
  ],
  // exports: [
  //     RegionsAdminComponent,
  //     RegionAdminDialogComponent,
  //     RegionsAddComponent
  // ]
})
export class RegionsAdminModule {}
